import React, { useState } from 'react'
import { Col, Row } from 'rsuite'
import RenderAssessmentView from './RenderAssessmentView'

export default function MAndESelfView({ schema, ...props }) {
  return (
    <>
      <Row style={{ marginTop: 10 }}>
        <Col lg={24} md={24} sm={24} xs={24}>
          <b>{schema.position.label} : </b>
          {schema.position.valueDef}
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <b>{schema.otherPosition.label} : </b>
          {schema.otherPosition.value}
        </Col>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <RenderAssessmentView assessments={schema.basicInfos || []} />
      </Row>
      <Row style={{ marginTop: 10 }}>
        <RenderAssessmentView assessments={schema.assessments || []} />
      </Row>
    </>
  )
}
